import { storeArq } from "correos-arq-utils";

export const clearSubmenuForDetail = () => {
  try {
    storeArq.load();
    storeArq.data.auth.userInfo.subMenu = { childs: [], parent: "/envio" };
    storeArq.save();
  } catch {}
};

export const lastUrlKey = "lastListUrl";

export const saveLastListUrl = (url) => {
  try {
    sessionStorage.setItem(lastUrlKey, url);
  } catch {}
};

export const readLastListUrl = () => {
  try {
    return sessionStorage.getItem(lastUrlKey);
  } catch {
    return null;
  }
};

export const referrerPath = () => {
  const ref = document.referrer;
  if (!ref) return null;
  try {
    const u = new URL(ref);
    return u.origin === window.location.origin ? u.pathname + u.search : null;
  } catch {
    return null;
  }
};
